export { default } from '../(root)/index';
export * from '../(root)/index';
